<button mat-stroked-button class="view-button" [glxyPopover]="viewsMenu" (click)="handleViewsClick()">
  {{ selectedFilterName() }}
  <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
</button>

<glxy-popover
  #viewsMenu
  [closeOnBackdropClick]="true"
  [closeOnEscapeKey]="true"
  [hasArrow]="true"
  [maxWidth]="'300px'"
  [maxHeight]="'360px'"
  [positions]="popoverPosition"
  [mobileFullScreen]="true"
  [breakpoint]="mobileWidth"
>
  <glxy-popover-title>
    {{ 'VIEWS.VIEWS' | translate }}
  </glxy-popover-title>
  <ng-container *ngIf="mode === 'list'; then listTemplate; else saveTemplate"></ng-container>
  <glxy-popover-actions>
    <ng-container *ngIf="mode === 'list'; then listActions; else saveActions"></ng-container>
  </glxy-popover-actions>
</glxy-popover>

<ng-template #listTemplate>
  <div class="view-list" *ngIf="hasFilters(); else noViews">
    <div *ngFor="let filter of allFilters()" class="view-item-container">
      <button mat-button class="view-item" type="button" (click)="handleSelectFilterClick(filter)">
        {{ filter.name }}
      </button>
      <button
        *ngIf="!filter.preset"
        mat-button
        class="delete-view-item"
        type="button"
        (click)="handleDeleteFilterClick(filter)"
      >
        <mat-icon class="delete-view-item__icon">delete</mat-icon>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #listActions>
  <button mat-flat-button color="primary" (click)="handleCreateViewClick()">
    {{ 'VIEWS.ACTIONS.CREATE_VIEW' | translate }}
  </button>
</ng-template>

<ng-template #noViews>
  <glxy-empty-state [size]="'small'">
    <glxy-empty-state-hero>
      <mat-icon>filter_list</mat-icon>
    </glxy-empty-state-hero>
    <p>{{ 'VIEWS.EMPTY' | translate }}</p>
  </glxy-empty-state>
</ng-template>

<ng-template #saveTemplate>
  <glxy-form-field class="new-view-name-input">
    <glxy-label>{{ 'VIEWS.VIEW_NAME' | translate }}</glxy-label>
    <input matInput [formControl]="newViewNameCtrl" />
    <ng-container *ngIf="newViewNameCtrl.touched">
      <glxy-error *ngIf="newViewNameCtrl.errors?.['required']">
        {{ 'VIEWS.ERRORS.VIEW_NAME_REQUIRED' | translate }}
      </glxy-error>
      <glxy-error *ngIf="newViewNameCtrl.errors?.['presetName']">
        {{ 'VIEWS.ERRORS.EQUAL_TO_PRESET_NAME' | translate }}
      </glxy-error>
      <glxy-error *ngIf="newViewNameCtrl.errors?.['nameLength']">
        {{ 'VIEWS.ERRORS.VIEW_NAME_TOO_LONG' | translate }}
      </glxy-error>
    </ng-container>
  </glxy-form-field>
</ng-template>
<ng-template #saveActions>
  <button mat-flat-button type="button" color="primary" (click)="handleSaveClick()">
    {{ 'ACTIONS.CREATE' | translate }}
  </button>
  <button mat-stroked-button type="button" (click)="handleCancelClick()">{{ 'ACTIONS.CANCEL' | translate }}</button>
</ng-template>
